export const BRAND_COLOR_SLOTS = 6;

export const normalizeBrandColor = (value: unknown): string => {
    if (typeof value !== "string") {
        return "";
    }

    return value
        .trim()
        .replace(/^#/, "")
        .toUpperCase();
};

export const isValidBrandColor = (value: unknown): boolean =>
    /^[0-9A-F]{6}$/.test(normalizeBrandColor(value));

export const createBrandColorSlots = (
    primaryColor: unknown,
    configuredColors: unknown
): string[] => {
    const savedColors = Array.isArray(configuredColors) ? configuredColors : [];

    return Array.from({ length: BRAND_COLOR_SLOTS }, (_, index) => {
        if (index === 0) {
            return (
                normalizeBrandColor(primaryColor) ||
                normalizeBrandColor(savedColors[0])
            );
        }

        return normalizeBrandColor(savedColors[index]);
    });
};

export const createBeeBrandColorPalette = (
    primaryColor: unknown,
    configuredColors: unknown
): string[] =>
    Array.from(
        new Set(
            createBrandColorSlots(primaryColor, configuredColors)
                .filter(isValidBrandColor)
                .map(color => `#${color}`)
        )
    );
